import { render, staticRenderFns } from "./selectAdminOneCommunity.vue?vue&type=template&id=6315072c"
import script from "./selectAdminOneCommunity.vue?vue&type=script&lang=js"
export * from "./selectAdminOneCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports